export const FeedDummyData = [
  {
    "image": "https://tistory1.daumcdn.net/tistory/1458907/attach/b95d2628c43b49e7aa662cf8c8fce44f",
    "subscribers": 525,
    "nickname": "고독검객",
    "description": "고독검객님의 블로그입니다.",
    "subscribing": false,
    "id": 1458907,
    "title": "고독검객의 블로그",
    "followerCount": "548",
    "defaultUrl": "https://sman76.tistory.com"
  },
  {
    "image": "https://t1.daumcdn.net/cfile/tistory/99FAD3455AEBABE52B",
    "subscribers": 332,
    "nickname": "홍형2",
    "description": "홍형2님의 블로그입니다.",
    "subscribing": false,
    "id": 2808917,
    "title": "대구사는 홍형",
    "followerCount": "355",
    "defaultUrl": "https://hong2young.tistory.com"
  },
  {
    "image": "https://tistory1.daumcdn.net/tistory/962869/attach/7c5c46eebae34b59874efab0a00bf57e",
    "subscribers": 449,
    "nickname": "둘리토비",
    "description": "둘리토비님의 블로그입니다.",
    "subscribing": false,
    "id": 962869,
    "title": "둘리토비의 스토리&북유럽",
    "followerCount": "482",
    "defaultUrl": "https://doolytubbies.tistory.com"
  },
  {
    "image": "https://tistory1.daumcdn.net/tistory/2984475/attach/7642617748f441c7856894ec8fd9e194",
    "subscribers": 410,
    "nickname": "나무하나만",
    "description": "나무하나만님의 블로그입니다.",
    "subscribing": false,
    "id": 2984475,
    "title": "핫플레이스 거기",
    "followerCount": "459",
    "defaultUrl": "https://hotpoint100.tistory.com"
  },
  {
    "image": "https://t1.daumcdn.net/cfile/tistory/99A1B9335AD99AF30D",
    "subscribers": 639,
    "nickname": "노르웨이펭귄🐧",
    "description": "노르웨이펭귄🐧님의 블로그입니다.",
    "subscribing": false,
    "id": 2904487,
    "title": "노르웨이와 한국에서 놀고 먹고 사랑하는 이야기",
    "followerCount": "679",
    "defaultUrl": "https://pyb9121.tistory.com"
  },
  {
    "image": "https://tistory1.daumcdn.net/tistory/1661197/attach/0e54a0729e8c4ab69e09e31d34020f5f",
    "subscribers": 279,
    "nickname": "등산바이블",
    "description": "등산바이블님의 블로그입니다.",
    "subscribing": false,
    "id": 1661197,
    "title": "등산바이블",
    "followerCount": "291",
    "defaultUrl": "https://thankspizza.tistory.com"
  }
]